import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bashboard_studnet_manger",
  "use": "icon-bashboard_studnet_manger-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 36 36\" id=\"icon-bashboard_studnet_manger\">\n<path d=\"M21.9,18.3c0.7-0.4,1.2-1,1.7-1.6c1.6-1.5,2.6-3.7,2.6-6.1c0-4.6-3.7-8.3-8.3-8.3c-4.6,0-8.3,3.7-8.3,8.3\n\tc0,2.8,1.4,5.3,3.6,6.8c0.3,0.3,0.7,0.6,1,0.8C7.7,20,3,25.9,3,32.8c0,0.4,0.4,0.8,0.8,0.8h28.4c0.4,0,0.8-0.4,0.8-0.8\n\tC33,25.9,28.3,20,21.9,18.3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol